// Add to cart form handler
document.addEventListener('DOMContentLoaded', function() {
  const addToCartForm = document.getElementById('add-to-cart-form');
  
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(addToCartForm);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Redirect to cart page after successful add
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error:', error);
        alert('There was an error adding to cart. Please try again.');
      });
    });
  }
});

